import React from "react"
import ReactTooltip from 'react-tooltip'

class NewTest extends React.Component {
  constructor(props) {
    super(props);

    this.state = this.getInitialState();
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFieldsChange = this.handleFieldsChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  getInitialState() {
    let state;
    state = {
      isTutor: false,
      isTimed: false,
      questionMode: 'all',
      questionCount: this.props.maxQuestions,
      allowedMinutes: '15',
      inProgress: false,
    };

    this.props.questionTypes.forEach(x => {
      state[`type${x}`] = true;
    });
    this.props.fields.forEach(field => {
      state[`field${field.id}`] = true;
    });
    this.props.subfields.forEach(subfield => {
      state[`subfield${subfield.id}`] = true;
    });
    return state;
  }
  handleSubmit() {
    const data = {
      is_tutor: this.state.isTutor,
      is_timed: this.state.isTimed,
      question_mode: this.state.questionMode,
      question_types: this.props.questionTypes.filter(x => this.state[`type${x}`]).join(','),
      fields: this.props.fields.filter(x => this.state[`field${x.id}`]).map(x => x.id),
      subfields: this.props.subfields.filter(x => this.state[`subfield${x.id}`]).map(x => x.id),
      question_count: this.state.questionCount,
      allowed_minutes: this.state.allowedMinutes
    };

    const selected = this.props.subfields.filter(x => this.state[`subfield${x.id}`]).length;

    if (selected === 0) {
      data.fields = this.props.fields.map(x => x.id);
      data.subfields = this.props.subfields.map(x => x.id);
    }

    this.setState({inProgress: true});
    fetch(`/api/v1/subscriptions/${this.props.subscription.id}/tests`, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: "same-origin",
      body: JSON.stringify(data),
    }).then(data => data.json())
    .then(json => {
      if (json["error"]) {
        alert(json["error"]);
      } else {
        window.location.href = `/dashboard/subscriptions/${this.props.subscription.id}/tests/${json.id}`
      }
      this.setState({inProgress: false});
    })
    .catch(err => {
      alert("There has been an error");
      this.setState({inProgress: false})
    })
  }
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }
  handleQuestionTypeChange = (event) => {
    const target = event.target;
    const value = target.checked;
    const name = target.name;

    this.setState({
      [name]: !value
    });

  };
  handleQuestionModeChange = (event) => {
    const target = event.target;
    const value = target.checked;
    const name = target.name;

    if (value) {
      this.setState({
        questionMode: name
      });
    }
  };
  handleFieldInputChange = (event) => {
    const checked = event.target.checked;
    const name = event.target.name;
    if (checked) {
      this.props.subfields.filter(x => x.fieldId == name.substr(5)).forEach(field => {
        const name = `subfield${field.id}`;
        this.setState({[name]: true});
      });
    } else {
      this.props.subfields.filter(x => x.fieldId == name.substr(5)).forEach(field => {
        const name = `subfield${field.id}`;
        this.setState({[name]: false});
      });
    }
    this.setState({
      [name]: checked
    });
  };
  handleFieldsChange(event) {
    const checked = event.target.checked;
    if (checked) {
      this.props.fields.forEach(field => {
        const name = `field${field.id}`;
        this.setState({[name]: true});
      });
      this.props.subfields.forEach(field => {
        const name = `subfield${field.id}`;
        this.setState({[name]: true});
      });
    } else {
      this.props.fields.forEach(field => {
        const name = `field${field.id}`;
        this.setState({[name]: false});
      });
      this.props.subfields.forEach(field => {
        const name = `subfield${field.id}`;
        this.setState({[name]: false});
      });
    }
  }
  questionTypesCount = (qType) => {
    const selector = this.state.questionMode === "all" ? "total" : this.state.questionMode;
    return this.props.questionTypesCount[`${selector}Count`][qType];
  };
  questionModeCount = (qMode) => {
    const selector = qMode === "all" ? "total" : qMode;
    return this.props.questionTypes.reduce((acc, qType) =>
      acc + this.props.questionTypesCount[`${selector}Count`][qType], 0);
  };
  subfieldTotalQuestionCount = (subfield) =>
    this.props.questionTypes.reduce((acc, qType) =>  acc + subfield['totalCount'][qType], 0);
  subfieldQuestionCount = (subfield) => {
    const selector = this.state.questionMode === "all" ? "total" : this.state.questionMode;
    return this.props.questionTypes.reduce((acc, qType) => acc + (this.state[`type${qType}`] ? subfield[`${selector}Count`][qType] : 0), 0);
  };
  fieldQuestionCount = (field) => {
    const subfields = this.props.subfields
        .filter(x => x.fieldId === field.id);

    if (subfields.length > 0) {
      return subfields.reduce((acc, x) =>
          acc + this.subfieldQuestionCount(x), 0);
    } else {
      const selector = this.state.questionMode === "all" ? "total" : this.state.questionMode;
      return this.props.questionTypes.reduce((acc, qType) => acc + (this.state[`type${qType}`] ? field[`${selector}Count`][qType] : 0), 0);
    }
  };
  render () {
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-12">
            <div className="card shadow">
              <div className="d-block card-header py-3">
                <h6 className="m-0 font-weight-bold text-primary">
                  Mode
                </h6>
              </div>
              <div className="collapse show">
                <div className="card-body">
                  <div className="form form-inline">
                    <div className="custom-control custom-checkbox">
                      <span className="switch">
                        <input type="checkbox"
                             name="isTutor"
                             className="switch-sm"
                             checked={this.state.isTutor}
                             onChange={this.handleInputChange}
                             id="tutor"/> 
                        <label htmlFor="tutor">{this.props.t['tutor']}</label>
                      </span>
                      <button className="badge badge-primary badge-pill ml-2 mr-3" data-tip= {this.props.t['tutor_text']}>?</button>
                      <ReactTooltip place="right" type="dark" effect="solid"/>
                      <p></p>
                      <span className="switch">
                        <input type="checkbox"
                             name="isTimed"
                             className="switch-sm"
                             checked={this.state.isTimed}
                             onChange={this.handleInputChange}
                             id="timed"/>
                        <label htmlFor="timed">{this.props.t['timed']}</label>
                      </span>
                    </div>
                    {
                      this.state.isTimed &&
                      <div className="ml-4 form-inline">
                        <input type="number"
                               step="1"
                               className="form-control"
                               id="minutes_allowed"
                               value={this.state.allowedMinutes}
                               onChange={(event) => this.setState({allowedMinutes: event.target.value})}
                               required/>
                        <label className="ml-2" htmlFor="questions_cnt">minutes</label>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      <div className="row mt-3">
        <div className="col-12">
          <div className="card shadow">
            <div className="d-block card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">
                {this.props.t['question_mode']}
              </h6>
            </div>
            <div className="collapse show" id="questionMode">
              <div className="card-body" onChange={this.handleInputChange}>
                <div className="container pl-0 ml-0">
                  <div className="custom-control custom-radio custom-control-inline col-lg-auto">
                    <input type="radio" id="questionModeAll"
                          name="questionMode"
                          value="all"
                          checked={this.state.questionMode === "all"}
                          onChange={this.handleInputChange}
                          className="custom-control-input" />
                    <label className="custom-control-label"
                          htmlFor="questionModeAll">
                      {this.props.t['all_questions']}
                      <span className="badge badge-primary ml-2 badge-pill">{this.questionModeCount("all")}</span>
                    </label>
                  </div>
                  <div className="custom-control custom-radio custom-control-inline col-lg-auto">
                    <input type="radio" id="questionModeUnused"
                          name="questionMode"
                          checked={this.state.questionMode === "unused"}
                          onChange={this.handleInputChange}
                          value="unused"
                          className="custom-control-input" />
                    <label className="custom-control-label" htmlFor="questionModeUnused">
                      {this.props.t['unused_questions']}
                      <span className="badge badge-primary ml-2 badge-pill">{this.questionModeCount("unused")}</span>
                    </label>
                  </div>
                  <div className="custom-control custom-radio custom-control-inline col-lg-auto">
                    <input type="radio" id="questionModeIncorrect"
                          name="questionMode"
                          checked={this.state.questionMode === "incorrect"}
                          onChange={this.handleQuestionModeChange}
                          value="incorrect"
                          className="custom-control-input" />
                    <label className="custom-control-label"
                          htmlFor="questionModeIncorrect">
                      {this.props.t['incorrect_questions']}
                      <span className="badge badge-primary ml-2 badge-pill">{this.questionModeCount("incorrect")}</span>
                    </label>
                  </div>
                  <div className="custom-control custom-radio custom-control-inline col-lg-auto">
                    <input type="radio" id="questionModeFlagged"
                          name="questionMode"
                          checked={this.state.questionMode === "flagged"}
                          onChange={this.handleQuestionModeChange}
                          value="flagged"
                          className="custom-control-input" />
                    <label className="custom-control-label"
                          htmlFor="questionModeFlagged">
                      {this.props.t['flagged_questions']}
                      <span className="badge badge-primary ml-2 badge-pill">{this.questionModeCount("flagged")}</span>
                    </label>
                  </div>
                </div>
                <div className="mt-4">
                {
                  this.props.questionTypes.map((x) =>
                      <div className="custom-control custom-checkbox custom-control-inline" key={x}>
                        <input type="checkbox" id={`type${x}`}
                               name={`type${x}`}
                               value="all"
                               checked={this.state[`type${x}`]}
                               onChange={this.handleQuestionTypeChange}
                               className="custom-control-input"/>
                        <label className="custom-control-label"
                               htmlFor={`type${x}`}>
                          {x === "K" ? "K\'"  : x === "T/F" ? this.props.t['question_true_false'] : x}
                          <span className="badge badge-primary ml-2 badge-pill">{this.questionTypesCount(x)}</span>
                        </label>
                      </div>
                  )
                }
                </div>
             </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-12">
          <div className="card shadow">
            <div className="d-block card-header py-3">
              <div className="custom-control custom-checkbox">
                <input type="checkbox"
                       className="custom-control-input"
                       checked={this.props.subfields.map(x => this.state[`subfield${x.id}`]).every(x => x)}
                       id="fields"
                       onChange={this.handleFieldsChange}/>
                <label className="custom-control-label font-weight-bold text-primary" htmlFor="fields">
                  {this.props.t['fields']}
                  <span className="badge badge-primary ml-2 badge-pill">{
                    this.props.subfields.filter(x => this.state[`subfield${x.id}`])
                        .reduce((acc, x) => acc + this.subfieldQuestionCount(x), 0)
                  }
                  </span>
                </label>
              </div>
            </div>
            <div className="collapse show" id="chapters">
              <div className="card-body">
                {
                  this.props.fields.filter(field => this.fieldQuestionCount(field) > 0).map(field =>
                    <div className="custom-control custom-checkbox"
                      key={`field-div-${field.id}`}>
                      <input type="checkbox"
                        className="custom-control-input"
                        name={`field${field.id}`}
                        checked={this.props.subfields
                          .filter(x => x.fieldId === field.id)
                          .map(x => this.state[`subfield${x.id}`]).every(x => x)}
                        onChange={this.handleFieldInputChange}
                        id={`field-${field.id}`} />
                      <label className="custom-control-label" htmlFor={`field-${field.id}`}>
                        { field.name }
                        <span className="badge badge-primary ml-2 badge-pill">{this.fieldQuestionCount(field)}</span>
                      </label>
                      {
                        this.props.subfields.filter(x => !((x.name == "Adhoc" || x.name == "Autre" || x.name == "Other") && this.fieldQuestionCount(field) === this.subfieldTotalQuestionCount(x))).filter(x => x.fieldId === field.id && this.subfieldQuestionCount(x) > 0).map(subfield =>
                          <div className="custom-control custom-checkbox" key={`subfield-div-${subfield.id}`}>
                            <input type="checkbox"
                              className="custom-control-input"
                              name={`subfield${subfield.id}`}
                              onChange={this.handleInputChange}
                              checked={this.state[`subfield${subfield.id}`]}
                              id={`subfield-${subfield.id}`} />
                            <label className="custom-control-label" htmlFor={`subfield-${subfield.id}`}>
                              { subfield.name }
                              <span className="badge badge-primary ml-2 badge-pill">{this.subfieldQuestionCount(subfield)}</span>
                            </label>
                          </div>)
                      }
                    </div>)
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-12">
          <div className="card shadow">
            <div className="d-block card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">
                {this.props.t['nb_of_questions']}
              </h6>
            </div>
            <div className="collapse show" id="numberOfQuestions">
              <div className="card-body">
                <div className="form-inline">
                  <input type="number"
                    step="1"
                    className="form-control"
                    id="questions_cnt"
                    value={this.state.questionCount}
                    onChange={(event) => this.setState({questionCount: event.target.value})}
                    required />
                  <label className="ml-2" htmlFor="questions_cnt">
                    {this.props.t['max_per_test']}
                    <span className="badge badge-primary ml-2 badge-pill">{this.props.maxQuestions}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-12 mb-4">
          <button
            onClick={this.handleSubmit}
            disabled={this.state.inProgress}
            className="btn btn-primary">
            {this.props.t['generate_test']}
          </button>
        </div>
      </div>
      </React.Fragment>
    );
  }
}

export default NewTest



// WEBPACK FOOTER //
// app/javascript/components/NewTest.js